import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  // The PRD's tier pill: the plan's name in the brand colour on its tint, with the info icon inside the pill's end.
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    flexShrink: 0,
    padding: '1px 2px 1px 10px',
    borderRadius: '999px',
    backgroundColor: alpha(palette.primary.main, 0.1),
    color: palette.primary.dark,
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle'
  },
  tip: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  tipTitle: {
    fontWeight: 600
  }
});
export default useStyles;